import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import  axios  from  'axios'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import moment from 'moment'


//import VueSocketIO from 'vue-socket.io';

Vue.prototype.$http = axios;
const  accessToken = localStorage.getItem('token') 

import Vuetify from 'vuetify'
Vue.use(Vuetify)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

Vue.use(require('vue-moment'));

import Nl2br from 'vue-nl2br'
Vue.component('nl2br', Nl2br)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
 

import i18n from './i18n'


if (accessToken) {
  Vue.prototype.$http.defaults.headers.common['x-access-token'] = accessToken
}  

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YY HH:mm') 
  }
});      
    
Vue.config.productionTip = true                  
  
if (Vue.config.productionTip) {
  
}
else {   

}



//Vue.prototype.$uploadHostname = (Vue.config.productionTip) ? '/momentup' : 'http://'+Vue.config.subdomain+'.kindyapp.dd/momentup'
Vue.prototype.$apiBase = (Vue.config.productionTip) ? "https://checklisten-designer.gloo.io/api"  : "http://localhost:3000" 
Vue.prototype.$socketBase = (Vue.config.productionTip) ? "https://checklisten-designer.gloo.io"  : "http://localhost:3003" 

Vue.prototype.$http.defaults.baseURL = Vue.prototype.$apiBase;
  


/*
Vue.use(new VueSocketIO({
  debug: true,
  connection: Vue.prototype.$socketBase
  //options: { path: "/my-app/" } //Optional options
}))
*/


new Vue({
  router,
  store,
  render: h => h(App),
  i18n
}).$mount('#app')
